import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/steamconnect.webp';
import screenshot_target from '../../../images/letterfunnel/dennisschabracq.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Dennis Schabracq"
      firstname="Dennis"
      companyname="Steam-connect"
      competition="Contact Center Live en Talkdesk"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/dennisschabracq.js